module.exports = __webpack_public_path__ + "img/Compo3D2.65ba3814.jpg";